import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { ValueChangedEvent } from "devextreme/ui/text_box";
import {
  WysiwygEditorComponent,
  WysiwygEngine
} from "src/app/components/ui/wysiwyg-editor/wysiwyg-editor.component";
import {
  ReportDesignItemTextArea,
  ReportDesignItemTextAreaConfig
} from "src/app/modules/bootstrap/modules/report/report-design-item";

@Component({
  selector: "snt-report-designer-textarea",
  templateUrl: "report-designer-textarea.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerTextareaComponent {
  @ViewChild("textEditor")
  sntTitleWysiwygEditorComponent: WysiwygEditorComponent | undefined;

  @ViewChild("defaultContentEditor")
  sntContentWysiwygEditorComponent: WysiwygEditorComponent | undefined;

  formData: { text: string; default: string } = {
    text: "",
    default: ""
  };

  @Input()
  item: ReportDesignItemTextArea | undefined;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readonly: boolean = false;

  @Output()
  config: EventEmitter<ReportDesignItemTextAreaConfig> = new EventEmitter();

  protected readonly WysiwygEngine = WysiwygEngine;

  ngOnInit(): void {
    this.formData.text = this.item?.config?.text || "";
    this.formData.default = this.item?.config?.default || "";
  }

  onTitleChanged(dxEvent: ValueChangedEvent): void {
    this.formData.text = dxEvent.value;

    this.config.emit({
      ...this.item!.config,
      text: dxEvent.value
    });
  }

  onContentChanged(): void {
    this.config.emit({
      ...this.item!.config,
      default: this.sntContentWysiwygEditorComponent?.getContent() || ""
    });
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "textarea",
      config: {
        text: this.formData.text,
        default: this.formData.default
      }
    };
  }
}
